import { relatorios } from '../utils/constants'
const router = function (permissions) {
  return ({
    path: 'relatorio',
    component: () => import('@/views/Relatorio/RelatorioModule.vue'),
    meta: { permissions },
    children: [
      {
        path: '/',
        redirect: '/',
      },
      {
        path: relatorios.servicosProdutor,
        meta: { permissions, title: 'Serviços por produtor', relatorio: relatorios.servicosProdutor },
        component: () => import('@/views/Relatorio/RelServicosPorProdutor.vue'),
      },
      {
        path: relatorios.servicoTecnicos,
        meta: { permissions, title: 'Serviços por Técnicos', relatorio: relatorios.servicoTecnicos },
        component: () => import('@/views/Relatorio/RelServicosPorTecnico.vue'),
      },
      {
        path: relatorios.atendimentoEmpresa,
        meta: { permissions, title: 'Atendimentos por Empresa', relatorio: relatorios.atendimentoEmpresa },
        component: () => import('@/views/Relatorio/RelAtendimentoPorEmpresa.vue'),
      },
      {
        path: relatorios.resumoServicos,
        meta: { permissions, title: 'Resumo dos Serviços', relatorio: relatorios.resumoServicos },
        component: () => import('@/views/Relatorio/RelResumoServicos.vue'),
      },
    ],
  })
}

export default {
  router,
}
